<div class="identi-table-wrapper container py-5" [class.rebranded]="useRebranded">
  <div class="row mb-5">
    <div class="col-12 text-center">
      <h4>
        <b>Our Plans</b>
      </h4>
    </div>
  </div>

  <div class="table-subheader-line-wrapper">
    <div class="first-column"></div>
    <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-subcolumn identi-subcolumn-top text-center"
      [class.identi-subcolumn-top-highlighted]="!!basicPlusHighlighted"
      [class.identi-subcolumn-highlighted]="!!basicPlusHighlighted">
      <h4>
        <b>{{ plan1Name }}</b>
      </h4>
      <h5>{{ plan1YearlyPrice }}/year</h5>
    </div>
    <div *appFeatureFlag="'isIdentialertAvailable'" class="identi-subcolumn identi-subcolumn-top text-center"
      [class.identi-subcolumn-top-highlighted]="!!alertHighlighted"
      [class.identi-subcolumn-highlighted]="!!alertHighlighted">
      <h4>
        <b>{{ plan2Name }}</b>
      </h4>
      <h5>{{ plan2YearlyPrice }}/year</h5>
      <ng-container *ngIf="plan2MonthlyPrice">
        <h6>OR</h6>
        <h5>{{ plan2MonthlyPrice }}/month</h5>
        <h6>(12 month contract)</h6>
      </ng-container>
    </div>
  </div>
  <div class="table-line-wrapper table-line-wrapper-without_line">
    <div class="first-column column-orange-background">
      <h3 class="mb-0 mt-0 brand-specific-heading-color"><b>Simple registration</b></h3>
    </div>
    <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"></div>
    <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
      [class.identi-column-highlighted]="!!alertHighlighted"></div>
  </div>

  <!-- First section - START -->

  <div *ngIf="!isBrandPetlog" class="table-line-section">

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/certificate-black.png" />
        <div>Annual keeper certificate</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/secure-data.svg" />
        <div>Secure data storage</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/secure-helpline.svg" />
        <div>Missing pet helpline</div>
      </div>
      <div class="identi-column helpline-row-item" [class.text-highlight]="!!basicPlusHighlighted"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        24/7
      </div>
      <div class="identi-column helpline-row-item" [class.text-highlight]="!!alertHighlighted"
        *appFeatureFlag="'isIdentialertAvailable'" [class.identi-column-highlighted]="!!alertHighlighted">
        24/7
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/unlimited-account-changes.svg" />
        <div>Unlimited changes to your account</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper table-line-wrapper-without_line">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/single-membership-covers.svg" />
        <div>Covers all pets in your household with an identichip microchip</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

  </div>

  <div *ngIf="isBrandPetlog" class="table-line-section">

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/notification.svg" />
        <div>Instant microchip scan notifications</div>
      </div>
      <div class="identi-column helpline-row-item" [class.text-highlight]="!!basicPlusHighlighted"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        Email
      </div>
      <div class="identi-column helpline-row-item" [class.text-highlight]="!!alertHighlighted"
        *appFeatureFlag="'isIdentialertAvailable'" [class.identi-column-highlighted]="!!alertHighlighted">
        SMS & Email
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/single-membership-covers.svg" />
        <div>Multi-pet protection as standard</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/secure-helpline.svg" />
        <div>Access to 24/7 missing pet helpline</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/certificate-black.png" />
        <div>Annual keepership certificate</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/unlimited-account-changes.svg" />
        <div>Unlimited changes to your details</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/secure-data.svg" />
        <div>Secure data storage</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/holiday.svg" />
        <div>Holiday Mode</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper table-line-wrapper-without_line">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/account-management.svg" />
        <div>Online account access and management </div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img [src]="!basicPlusHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

  </div>

  <!-- First section - END -->

  <div class="table-line-wrapper table-line-wrapper-without_line">
    <div class="first-column column-orange-background">
      <h3 *ngIf="!isBrandPetlog" class="mb-0 mt-0 brand-specific-heading-color"><b>Lost Pet Protection cover</b></h3>
      <h3 *ngIf="isBrandPetlog" class="mb-0 mt-0 brand-specific-heading-color"><b>Lost Pet Support</b></h3>
    </div>
    <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"></div>
    <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
      [class.identi-column-highlighted]="!!alertHighlighted"></div>
  </div>

  <!-- Second section - START -->

  <div *ngIf="!isBrandPetlog" class="table-line-section">

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/vet-surgery-icon.svg" />
        <div>Instant alert when your pet’s chip is scanned</div>
      </div>
      <div class="identi-column helpline-row-item" [class.text-highlight]="!!basicPlusHighlighted"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        Email
      </div>
      <div class="identi-column helpline-row-item" [class.text-highlight]="!!alertHighlighted"
        *appFeatureFlag="'isIdentialertAvailable'" [class.identi-column-highlighted]="!!alertHighlighted">
        SMS & Email
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/missing-pet-social-media.svg" />
        <div>Missing pet social media sharing</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted"></div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/sms-alert.svg" />
        <div>SMS alerts to pet keepers in your area</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted"></div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/alert-to-police.svg" />
        <div>Alerts sent to pet finders within 20 miles</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted"></div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/missing-pet-poster.svg" />
        <div>Missing pet support, advice and materials</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted"></div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

  </div>

  <div *ngIf="isBrandPetlog" class="table-line-section">

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/missing-pet-social-media.svg" />
        <div>Missing pet social media sharing</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img src="/assets/images/identibase/identi-table-icons/cross.svg" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/alert-to-police.svg" />
        <div>Alerts to local vets, rescues, wardens & police</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img src="/assets/images/identibase/identi-table-icons/cross.svg" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>
    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/missing-pet-poster.svg" />
        <div>Edit, download and print your instant missing pet poster</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img src="/assets/images/identibase/identi-table-icons/cross.svg" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>

    </div>

    <div class="table-line-wrapper">
      <div class="first-column">
        <img src="/assets/images/identibase/identi-table-icons/missing-pet-support.svg" />
        <div>Missing pet support, advice and materials</div>
      </div>
      <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-column"
        [class.identi-column-highlighted]="!!basicPlusHighlighted">
        <img src="/assets/images/identibase/identi-table-icons/cross.svg" class="table-checkmark" />
      </div>
      <div class="identi-column" *appFeatureFlag="'isIdentialertAvailable'"
        [class.identi-column-highlighted]="!!alertHighlighted">
        <img [src]="!alertHighlighted ? regularIconSource : highlightedIconSource" class="table-checkmark" />
      </div>

    </div>




  </div>

  <!-- Second section - END -->

  <div class="table-subheader-line-wrapper">
    <div class="first-column"></div>
    <div *appFeatureFlag="'isIdentiPlusAvailable'" class="identi-subcolumn identi-subcolumn-bottom text-center"
      [class.identi-subcolumn-bottom-highlighted]="!!basicPlusHighlighted"
      [class.identi-subcolumn-highlighted]="!!basicPlusHighlighted"></div>
    <div *appFeatureFlag="'isIdentialertAvailable'" class="identi-subcolumn identi-subcolumn-bottom text-center"
      [class.identi-subcolumn-bottom-highlighted]="!!alertHighlighted"
      [class.identi-subcolumn-highlighted]="!!alertHighlighted"></div>
  </div>

  <div class="table-button-line-wrapper">
    <div class="first-column-placeholder"></div>
    <ng-container *appFeatureFlag="'isIdentiPlusAvailable'">
      <div class="identi-subcolumn-button-wrapper">
        <button *ngIf="buyButtonVisible || (!buyButtonVisible && !basicPlusHighlighted)" type="button" class="btn mt-4"
          [disabled]="buyButtonDisabled && !!basicPlusHighlighted" [class.orange-button]="!!basicPlusHighlighted"
          [class.outlined-button]="!basicPlusHighlighted"
          (click)="onIdentitableButtonClicked(IdentitableButtonEnum.IdentibasePlusButton)">
          {{ identibasePlusButtonLabel }}
        </button>
      </div>
    </ng-container>
    <ng-container *appFeatureFlag="'isIdentialertAvailable'">
      <div class="identi-subcolumn-button-wrapper">
        <button *ngIf="buyButtonVisible || (!buyButtonVisible && !alertHighlighted)" type="button" class="btn mt-4"
          [disabled]="buyButtonDisabled && !!alertHighlighted" [class.orange-button]="!!alertHighlighted"
          [class.outlined-button]="!alertHighlighted"
          (click)="onIdentitableButtonClicked(IdentitableButtonEnum.IdentialertButton)">
          {{ identialertButtonLabel }}
        </button>
      </div>
    </ng-container>
  </div>
</div>